import React, { type FC, type PropsWithChildren } from 'react';

import { isDefined } from '@lucid/utils';

import type { Lucid } from '../../../types/types';
import Box from '../../box/box';
import Text from '../../text/text';
import Heading from '../../heading/heading';
import ComparisonCard from './comparison-card';

export interface ComparisonCardGroupProps {
  /** Heading for Comparison Card Group */
  heading?: string;
  /** Subtitle for Comparison Card Group */
  subheading?: string;
  /** An list of Comparison Cards */
  comparisonCards?: Lucid.Directus.Generated.Comparison_Card_Item[];
}

const ComparisonCardGroup: FC<PropsWithChildren<ComparisonCardGroupProps>> = ({
  heading,
  subheading,
  comparisonCards,
}) => (
  <>
    {heading && (
      <Box
        css={theme => ({
          label: 'comparisonCardGroup',
          maxWidth: '680px',
          textAlign: 'center',
          margin: 'auto',
          marginBottom: theme.space.s80,
        })}
      >
        {heading && (
          <Heading as="h2" variant="heading2XL">
            {heading}
          </Heading>
        )}
        {subheading && <Text variant="paragraphM400">{subheading}</Text>}
      </Box>
    )}
    <Box
      css={theme => ({
        maxWidth: '1100px',
        gap: theme.space.s64,
        margin: 'auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        [theme.breakpoints.bp1024.max]: {
          flexDirection: 'column',
          alignItems: 'center',
        },
      })}
    >
      {(comparisonCards?.map(card => card.comparison_card_id) || []).filter(isDefined).map((card, index) => (
        <ComparisonCard key={`card-${index}`} card={card} />
      ))}
    </Box>
  </>
);

export default ComparisonCardGroup;
export { ComparisonCardGroup };
